import { IonButton, IonCol, IonContent, IonGrid, IonHeader, IonLabel, IonNote, IonRow,  IonToolbar, IonPopover } from '@ionic/react';
import React, { useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { globeOutline, locationSharp, phonePortraitOutline } from 'ionicons/icons';
import { Marcador } from '../interfaces';
import './MarkerInfoWindow.css'

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper';
import { useTranslation } from 'react-i18next';

import mxproficon from '../assets/logo.svg';
import cooperativa from '../assets/cooperativa-circle.svg';
import comidatipica from '../assets/molcajete-circle.svg';
import arqueolo from '../assets/piramide-circle.svg';
import chac from '../assets/chac-circle.svg';


const MarkerInfoWindow = ({
    marker,
    onDismiss,
  }: {
    marker : Marcador;
    onDismiss: () => void;
  }) => {
    useEffect(()=>{
        console.log(`../assets/imgCorredor/${marker.image1}`);
    },[]);
    const re = new RegExp("https://");
    const [t,i18n] = useTranslation("global");
    return (
        <>
            <IonHeader className='ion-no-border'>
                <IonToolbar id='modalMarkers' >
                </IonToolbar>
                {marker.image1?(
                    marker.image1.match(re)?(<img src={marker.image1}/>):(<img src={`/assets/imgCorredor/${marker.image1}`}/>))
                :("")}
            </IonHeader>
            <IonContent>
                {marker.imagenes?(
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                        }}
                        pagination={{
                        clickable: true,
                        }}
                        navigation={true}
                        modules={[Autoplay, Pagination, Navigation]}
                    >
                        <SwiperSlide><img className='imgintro' src={`/assets/imgCorredor/${marker.imagenes[0].url}`}/></SwiperSlide>
                        <SwiperSlide><img className='imgintro' src={`/assets/imgCorredor/${marker.imagenes[1].url}`}/></SwiperSlide>
                        <SwiperSlide><img className='imgintro' src={`/assets/imgCorredor/${marker.imagenes[2].url}`}/></SwiperSlide>
                    </Swiper>
                    ):("")
                }
                {marker.images?(
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                        }}
                        pagination={{
                        clickable: true,
                        }}
                        navigation={true}
                        modules={[Autoplay, Pagination, Navigation]}
                    >
                        <SwiperSlide><img className='imgintro' src={`${marker.images[0]}`}/></SwiperSlide>
                        <SwiperSlide><img className='imgintro' src={`${marker.images[1]}`}/></SwiperSlide>
                        <SwiperSlide><img className='imgintro' src={`${marker.images[2]}`}/></SwiperSlide>
                    </Swiper>
                    ):("")
                }
                <p></p>
                <IonGrid className='ion-padding'>
                    <IonRow className='padimagen'>
                        <IonCol size='12'>
                            <IonLabel>
                                <h1>{marker.nombreEstacion?(marker.nombreEstacion):(marker.nombrePolo)}</h1>
                                {marker.horarios?(<IonNote>{t("restaurant.open")} {marker.horarios}</IonNote>):("")}
                            </IonLabel>
                        </IonCol>
                    </IonRow>

                    <IonRow className='ion-margin-botton'>
                        <IonCol size='12' >
                            <IonLabel>
                                {marker.descripcion}
                            </IonLabel><br></br>
                            <IonRow content='center'>
                            <IonButton fill="outline" size="small" className="simple-icon" id="click-trig">
                                <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                            </IonButton>
                            <IonButton fill="outline" size="small" className="simple-icon" id="click-coop">
                                <img src={mxproficon} alt="Mas Información" id='icon-mxprof'/>
                            </IonButton>
                            <IonButton fill="outline" size="small" className="simple-icon" id="click-comi">
                                <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                            </IonButton>
                            <IonButton fill="outline" size="small" className="simple-icon" id="click-arq">
                                <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                            </IonButton>
                            <IonButton fill="outline" size="small" className="simple-icon" id="click-mus">
                                <img src={mxproficon} alt="Mas Información" id='icon-mxprof' />
                            </IonButton>
                            </IonRow>
                            <IonPopover trigger="click-trig" triggerAction="click">
                                <IonContent class="ion-padding">Sabías que Veracruz alberga el primer pueblo libre de esclavitud en América: San Lorenzo de los Negros (hoy Yanga), fundado en 1630.</IonContent>
                            </IonPopover>
                            <IonPopover trigger="click-coop" triggerAction="click">
                                <IonContent class="ion-padding">Sabías que Córdoba, Veracruz, fue la primera región en México donde se cultivó café en 1796, traído desde Cuba. .</IonContent>
                            </IonPopover>
                            <IonPopover trigger="click-comi" triggerAction="click">
                                <IonContent class="ion-padding">Sabías que El Carnaval de Veracruz (más famoso que el de Río, según los locales) se celebra desde 1866, pero pocos saben que su primera edición incluyó un desfile de barcos decorados en el malecón.</IonContent>
                            </IonPopover>
                            <IonPopover trigger="click-arq" triggerAction="click">
                                <IonContent class="ion-padding">Sabías que Tlacotalpan, pueblo patrimonio de la humanidad (UNESCO), con sus casas color pastel y calles adoquinadas, fue visitado por Gabriel García Márquez en los 80. Se dice que su atmósfera mágica influyó en su novela El amor en los tiempos del cólera.</IonContent>
                            </IonPopover>
                            <IonPopover trigger="click-mus" triggerAction="click">
                                <IonContent class="ion-padding">Sabías que en Isla de Sacrificios, frente al puerto de Veracruz, hay un cementerio sumergido de barcos españoles y un antiguo templo dedicado a Chalchiuhtlicue (diosa del agua).</IonContent>
                            </IonPopover>
                        </IonCol>
                    </IonRow>

                    <IonRow className='ion-justify-content-start ion-align-items-center'>
                        <IonCol size='1'>
                            <IonIcon icon={locationSharp} color="success" style={{fontSize: "1.5rem"}}/>
                        </IonCol>
                        <IonCol size='11'>{marker.direccion}</IonCol>
                    </IonRow>

                    <IonRow className='ion-justify-content-start ion-align-items-center'>
                        <IonCol size='1'>
                            <IonIcon icon={globeOutline} color="success" style={{fontSize: "1.5rem"}}/>
                        </IonCol>
                        <IonCol size='11'>{marker.sitioweb}</IonCol>
                    </IonRow>
                    
                    <IonRow className='ion-justify-content-start ion-align-items-center'>
                        <IonCol size='1'>
                            <IonIcon icon={phonePortraitOutline} color="success" style={{fontSize: "1.5rem"}}/>
                        </IonCol>
                        <IonCol size='11'>{marker.telefono}</IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size='9'>
                        </IonCol>
                        <IonCol size='3'>
                            <IonButton color='success' onClick={onDismiss}>
                                {t("artesanias.close-btn")}
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </>
    );
};

export default MarkerInfoWindow;